import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import LabelInfo from '../../../../../components/LabelInfo';
import { setNumberWithComma } from '../../../../../lib/common';
import './OrderReturnListSummaryBox.scss';

const OrderReturnListSummaryBox = (props) => {
  const { orderReturnSummaryBox } = props;

  return (
    <Panel className="order-return-list-summary-box">
      <div className="panel-body">
        <div className="order-return-list-summary-box-info">
          <div className="form-wrap">
            <LabelInfo label="반품 요청 건수" info={setNumberWithComma(orderReturnSummaryBox.returnRequestCnt, '건')} />

            <LabelInfo
              label="반품 요청 합계 금액"
              info={setNumberWithComma(orderReturnSummaryBox.returnRequestTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="반품 수거 완료 건수"
              info={setNumberWithComma(orderReturnSummaryBox.returnReceiveCnt, '건')}
            />

            <LabelInfo
              label="반품 수거 완료 금액"
              info={setNumberWithComma(orderReturnSummaryBox.returnReceiveTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="반품 처리 지연 건수"
              info={setNumberWithComma(orderReturnSummaryBox.returnDelayCnt, '건')}
            />

            <LabelInfo
              label="반품 처리 지연 금액"
              info={setNumberWithComma(orderReturnSummaryBox.returnDelayTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo label="반품 거부 건수" info={setNumberWithComma(orderReturnSummaryBox.returnRejectCnt, '건')} />

            <LabelInfo
              label="반품 거부 합계 금액"
              info={setNumberWithComma(orderReturnSummaryBox.returnRejectTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="반품 승인 건수"
              info={setNumberWithComma(orderReturnSummaryBox.returnCompleteCnt, '건')}
            />

            <LabelInfo
              label="반품 승인 합계 금액"
              info={setNumberWithComma(orderReturnSummaryBox.returnCompleteTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="반품 완료 건수"
              info={setNumberWithComma(orderReturnSummaryBox.refundCompleteCnt, '건')}
            />

            <LabelInfo
              label="반품 완료 합계 금액"
              info={setNumberWithComma(orderReturnSummaryBox.refundCompleteTotalPrice, '원')}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default OrderReturnListSummaryBox;
